import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import { FaComments, FaPaperPlane, FaTimes } from "react-icons/fa";

const MessageWidget = () => {
  const formRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [status, setStatus] = useState("");
  const [statusType, setStatusType] = useState("");
  const [isSending, setIsSending] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    const botField = formRef.current?.elements?.bot_field?.value;

    if (botField) {
      setStatus("Spam detected. Message not sent.");
      setStatusType("error");
      return;
    }

    setIsSending(true);
    setStatus("");
    setStatusType("");

    emailjs
      .sendForm(
        "service_vi0josa",
        "template_enh9l75",
        formRef.current,
        "Foxhp8JCuiPp-WgGq"
      )
      .then(
        () => {
          setStatus(
            "Thanks. Your message has been sent to CloudLogic IT Solutions. Someone will review it and get back to you shortly."
          );
          setStatusType("success");
          formRef.current.reset();
          setIsSending(false);
        },
        () => {
          setStatus("Sorry, your message could not be sent. Please try again.");
          setStatusType("error");
          setIsSending(false);
        }
      );
  };

  return (
    <div className={`message-widget ${isOpen ? "is-open" : ""}`}>
      {isOpen && (
        <div className="message-widget-panel">
          <div className="message-widget-header">
            <div>
              <span>Message CloudLogic</span>
              <strong>How can we help?</strong>
            </div>

            <button
              type="button"
              className="message-widget-close"
              onClick={() => setIsOpen(false)}
              aria-label="Close message form"
            >
              <FaTimes />
            </button>
          </div>

          <p className="message-widget-intro">
            Send a quick message about Microsoft 365, Azure, SharePoint, Teams,
            automation, security, governance, compliance readiness, or IT
            support.
          </p>

          <form ref={formRef} onSubmit={handleSubmit}>
            <div className="message-widget-honeypot" aria-hidden="true">
              <label htmlFor="message_widget_bot_field">Do not fill this out</label>
              <input
                id="message_widget_bot_field"
                name="bot_field"
                type="text"
                tabIndex="-1"
                autoComplete="off"
              />
            </div>

            <input type="hidden" name="subject" value="Website Message Widget" />

            <label htmlFor="message_widget_name">Name</label>
            <input
              id="message_widget_name"
              name="name"
              type="text"
              required
              placeholder="Your name"
            />

            <label htmlFor="message_widget_email">Email</label>
            <input
              id="message_widget_email"
              name="email"
              type="email"
              required
              placeholder="you@example.com"
            />

            <label htmlFor="message_widget_phone">Phone</label>
            <input
              id="message_widget_phone"
              name="phone_number"
              type="tel"
              placeholder="Optional"
            />

            <label htmlFor="message_widget_message">Message</label>
            <textarea
              id="message_widget_message"
              name="message"
              required
              rows="4"
              placeholder="What would you like to implement, improve, secure or govern?"
            />

            <button
              type="submit"
              className="message-widget-submit"
              disabled={isSending}
            >
              <FaPaperPlane />
              {isSending ? "Sending..." : "Send Message"}
            </button>

            <small>
              This is an enquiry message, not live chat. CloudLogic will reply
              after reviewing your request.
            </small>

            {status && (
              <div className={`message-widget-status ${statusType}`}>
                {status}
              </div>
            )}
          </form>
        </div>
      )}

      <button
        type="button"
        className="message-widget-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? "Close message form" : "Open message form"}
      >
        {isOpen ? <FaTimes /> : <FaComments />}
        <span>{isOpen ? "Close" : "Message us"}</span>
      </button>
    </div>
  );
};

export default MessageWidget;
